import {Component, EventEmitter, HostListener, Input, OnChanges, OnInit, Output, SimpleChanges} from '@angular/core';
import {SharedDataService} from '../../provider/shared-data/shared-data.service';
import {Location} from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {APP_ICON_PATH} from '../../../environments/environment';
import {SessionDataService} from '../../provider/session-data/session-data.service';
import {AlertController, AlertInput} from '@ionic/angular';
import {ALERT_TXT} from '../../strings/language';

@Component({
	selector: 'app-regisafe-header',
	templateUrl: './regisafe-header.component.html',
	styleUrls: ['./regisafe-header.component.scss'],
})
export class RegisafeHeaderComponent implements OnInit, OnChanges {

	@Input() isDetailPage = false;
	@Input() title = '';
	@Input() resultCounter: string;
	@Input() fromCache: boolean;
	@Input() sorting: boolean;
	@Input() sortFields: string;

	@Output() clickOnHeadlineTitle: EventEmitter<any> = new EventEmitter<any>();
	@Output() filter: EventEmitter<any> = new EventEmitter<any>();

	shared: any;
	appIconPath = APP_ICON_PATH;
	alert: HTMLIonAlertElement;
	searchSort = '';

	constructor(public sharedService: SharedDataService,
				public location: Location,
				private activatedRoute: ActivatedRoute,
				private sessionData: SessionDataService,
				private alertCtrl: AlertController) {

	}

	@HostListener('click', ['$event'])
	handleHeadlineClick(event) {
		if (event.target.id === 'objecttitle') {
			this.clickOnHeadlineTitle.emit(true);
		}
	}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.hasOwnProperty('sortFields')) {
			this.searchSort = changes.sortFields.currentValue;
		}
	}

	ngOnInit() {
		this.shared = this.sharedService.getRegisafeGlobalData();
		this.activatedRoute.queryParams.subscribe(values => {

		});
	}

	back(): void {
		this.location.back();
	}

	async filterResults(osId) {

		let input: Array<AlertInput> = [];
		switch (osId) {
			case 'Aktenplanverwaltung':
			input = [
				{
					label: 'Aktenzeichen aufsteigend',
					type: 'radio',
					name: 'filter',
					value: 'Aktenzeichen>',
					checked: this.searchSort === 'Aktenzeichen>'
				}, {
					label: 'Aktenzeichen absteigend',
					type: 'radio',
					name: 'filter',
					value: 'Aktenzeichen<',
					checked: this.searchSort === 'Aktenzeichen<'
				}
			];
			break;

			case 'VorgangsVerwaltung':
				input = [
					{
						label: 'Datum aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'BeginnDatum>',
						checked: this.searchSort === 'BeginnDatum>'
					}, {
						label: 'Datum absteigend',
						type: 'radio',
						name: 'filter',
						value: 'BeginnDatum<',
						checked: this.searchSort === 'BeginnDatum<'
					}, {
						label: 'Vorgangskennung aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Vorgangskennung>',
						checked: this.searchSort === 'Vorgangskennung>'
					}, {
						label: 'Vorgangskennung absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Vorgangskennung<',
						checked: this.searchSort === 'Vorgangskennung<'
					}
				];
				break;
			case 'Schriftgutverwaltung':
				input = [
					{
						label: 'Änderungsdatum aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'ADatum>',
						checked: this.searchSort === 'ADatum>'
					}, {
						label: 'Änderungsdatum absteigend',
						type: 'radio',
						name: 'filter',
						value: 'ADatum<',
						checked: this.searchSort === 'ADatum<'
					}, {
						label: 'Erstellungsdatum aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Datum>',
						checked: this.searchSort === 'Datum>'
					}, {
						label: 'Erstellungsdatum absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Datum<',
						checked: this.searchSort === 'Datum<'
					}, {
						label: 'Aktenzeichen aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Aktenzeichen>',
						checked: this.searchSort === 'Aktenzeichen>'
					}, {
						label: 'Aktenzeichen absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Aktenzeichen<',
						checked: this.searchSort === 'Aktenzeichen<'
					}
				];
				break;
			case 'Adressverwaltung':
				input = [
					{
						label: 'Adresskennung aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Adresskennung>',
						checked: this.searchSort === 'Adresskennung>'
					}, {
						label: 'Adresskennung absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Adresskennung<',
						checked: this.searchSort === 'Adresskennung<'
					}, {
						label: 'Name aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Nachname>;Vorname>',
						checked: this.searchSort === 'Nachname>;Vorname>'
					}, {
						label: 'Name absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Nachname<;Vorname<',
						checked: this.searchSort === 'Nachname<;Vorname<'
					}
				];
				break;
			case 'Sitzungsverwaltung':
				input = [
					{
						label: 'Sitzungsdatum aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Sitzungsdatum>',
						checked: this.searchSort === 'Sitzungsdatum>'
					}, {
						label: 'Sitzungsdatum absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Sitzungsdatum<',
						checked: this.searchSort === 'Sitzungsdatum<'
					}
				];
				break;
			default:
				input = [
					{
						label: 'Text aufsteigend',
						type: 'radio',
						name: 'filter',
						value: 'Text>',
						checked: this.searchSort === 'Text>'
					}, {
						label: 'Text absteigend',
						type: 'radio',
						name: 'filter',
						value: 'Text<',
						checked: this.searchSort === 'Text<'
					}
				];
		}

		this.alert = await this.alertCtrl.create({
			header: ALERT_TXT.header.str00050,
			buttons: [
				{
					text: ALERT_TXT.buttons.str00010,
					role: 'cancel'
				}, {
					text: ALERT_TXT.buttons.str00130,
					role: 'filter',
					handler: (data) => data
				}

			],
			inputs: input
		});

		await this.alert.present();

		await this.alert.onDidDismiss().then((filter) => {
			if (filter.role !== 'cancel') {
				this.searchSort = filter.data.values;
				this.filter.emit(filter.data);
			}
		});
	}


	/*
	openRadioAlert() {
		let alert = this.alertCtrl.create();
		alert.setTitle('Sortierung');

		alert.addInput({
			type: 'radio',
			label: 'Text alphabetisch aufsteigend',
			value: 'Text>',
			checked: this.searchSort === 'Text>'
		});
		alert.addInput({
			type: 'radio',
			label: 'Text alphabetisch absteigend',
			value: 'Text<',
			checked: this.searchSort === 'Text<'
		});

		if (this.category === 'Structure') {
			alert.addInput({
				type: 'radio',
				label: 'Aktenzeichen aufsteigend',
				value: 'Aktenzeichen>',
				checked: this.searchSort === 'Aktenzeichen>'
			});
			alert.addInput({
				type: 'radio',
				label: 'Aktenzeichen absteigend',
				value: 'Aktenzeichen<',
				checked: this.searchSort === 'Aktenzeichen<'
			});
		}

		if (this.category === 'Document') {
			alert.addInput({
				type: 'radio',
				label: 'Änderungsdatum aufsteigend',
				value: 'ADatum>',
				checked: this.searchSort === 'ADatum>'
			});
			alert.addInput({
				type: 'radio',
				label: 'Änderungsdatum absteigend',
				value: 'ADatum<',
				checked: this.searchSort === 'ADatum<'
			});

			alert.addInput({
				type: 'radio',
				label: 'Erstellungsdatum aufsteigend',
				value: 'Datum>',
				checked: this.searchSort === 'Datum>'
			});
			alert.addInput({
				type: 'radio',
				label: 'Erstellungsdatum absteigend',
				value: 'Datum<',
				checked: this.searchSort === 'Datum<'
			});

			alert.addInput({
				type: 'radio',
				label: 'Aktenzeichen aufsteigend',
				value: 'Aktenzeichen>',
				checked: this.searchSort === 'Aktenzeichen>'
			});
			alert.addInput({
				type: 'radio',
				label: 'Aktenzeichen absteigend',
				value: 'Aktenzeichen<',
				checked: this.searchSort === 'Aktenzeichen<'
			});
		}

		if (this.category === 'Folder') {
			alert.addInput({
				type: 'radio',
				label: 'Datum aufsteigend',
				value: 'BeginnDatum>',
				checked: this.searchSort === 'BeginnDatum>'
			});
			alert.addInput({
				type: 'radio',
				label: 'Datum absteigend',
				value: 'BeginnDatum<',
				checked: this.searchSort === 'BeginnDatum<'
			});

			alert.addInput({
				type: 'radio',
				label: 'Vorgangskennung aufsteigend',
				value: 'Vorgangskennung>',
				checked: this.searchSort === 'Vorgangskennung>'
			});
			alert.addInput({
				type: 'radio',
				label: 'Vorgangskennung absteigend',
				value: 'Vorgangskennung<',
				checked: this.searchSort === 'Vorgangskennung<'
			});
		}

		if (this.category === 'Address') {
			alert.addInput({
				type: 'radio',
				label: 'Adresskennung aufsteigend',
				value: 'Adresskennung>',
				checked: this.searchSort === 'Adresskennung>'
			});
			alert.addInput({
				type: 'radio',
				label: 'Adresskennung absteigend',
				value: 'Adresskennung<',
				checked: this.searchSort === 'Adresskennung<'
			});

			alert.addInput({
				type: 'radio',
				label: 'Name aufsteigend',
				value: 'Nachname>;Vorname>',
				checked: this.searchSort === 'Nachname>;Vorname>'
			});
			alert.addInput({
				type: 'radio',
				label: 'Name absteigend',
				value: 'Nachname<;Vorname<',
				checked: this.searchSort === 'Nachname<;Vorname<'
			});
		}

		if (this.category === 'Meeting') {
			alert.addInput({
				type: 'radio',
				label: 'Sitzungsdatum aufsteigend',
				value: 'Sitzungsdatum>',
				checked: this.searchSort === 'Sitzungsdatum>'
			});
			alert.addInput({
				type: 'radio',
				label: 'Sitzungsdatum absteigend',
				value: 'Sitzungsdatum<',
				checked: this.searchSort === 'Sitzungsdatum<'
			});
		}

		alert.addButton('Abbrechen');
		alert.addButton({
			text: 'OK',
			handler: data => {
				this.searchSort = data;

				// Sortierung in localstorage speichern
				this.storeSorting(data, this.category);

				if (data == 'Datum>' || data == 'Datum<') {
					this.switchDateNote = true;
				} else {
					this.switchDateNote = false;
				}
				this.searchInResultList(false);
			}
		});
		alert.present();
	}*/

}
